import * as React from 'react';
export const VUSvg = React.forwardRef(function VUSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#E25950',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M0 6v4.002C0 11.106.895 12 1.994 12h12.012A1.998 1.998 0 0 0 16 10.002V6H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M6.672 5H16v2H6.661L.8 11.396a.5.5 0 0 1-.151.077A2.01 2.01 0 0 1 0 9.991V2.01C0 1.419.253.889.656.52A.5.5 0 0 1 .8.596L6.672 5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M16 5.5v1H6.363L.308 11.063A2.007 2.007 0 0 1 0 10.043l5.396-4.067L.002 1.91C.02 1.54.138 1.196.33.904L6.427 5.5H16Z',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: 2,
        cy: 6,
        r: 1,
        fill: '#FCD669',
      }),
    ),
  );
});
VUSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var VU = {
  category: 'flag',
  colorable: false,
  name: 'VU',
  svg: VUSvg,
};
